var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAOneOffBonus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "67px",
    viewBox: "0 0 66 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "84.8805747%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092176",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092398",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "1.44469277e-05%",
    cy: "84.2874019%",
    fx: "1.44469277e-05%",
    fy: "84.2874019%",
    r: "324.864217%",
    gradientTransform: "translate(0.000000,0.842874),scale(1.000000,0.402321),rotate(-73.960230),translate(-0.000000,-0.842874)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B515F3",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28FDCA",
    stopOpacity: 0.863718313,
    offset: "43.6124505%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCFF",
    stopOpacity: 0.277453016,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "69.6004904%",
    cy: "9.56588355%",
    fx: "69.6004904%",
    fy: "9.56588355%",
    r: "165.094611%",
    gradientTransform: "translate(0.696005,0.095659),scale(1.000000,0.437667),rotate(-72.632667),translate(-0.696005,-0.095659)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28FDCA",
    stopOpacity: 0.863718313,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B515F3",
    stopOpacity: 0.524803322,
    offset: "45.098712%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCFF",
    stopOpacity: 0.277453016,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "19.3522319%",
    cy: "78.2813872%",
    fx: "19.3522319%",
    fy: "78.2813872%",
    r: "372.279599%",
    gradientTransform: "translate(0.193522,0.782814),scale(1.000000,0.347669),rotate(-76.047760),translate(-0.193522,-0.782814)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C124FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AF4EC",
    stopOpacity: 0.581075175,
    offset: "43.6124505%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99DCFF",
    stopOpacity: 0.277453016,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.62427746%",
    y1: "52.3121387%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70FFE8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reduce-Fees",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-380.000000, -267.000000)",
    fillRule: "nonzero",
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-(18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-18"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-1)",
    cx: 44.0904977,
    cy: 35.1144231,
    r: 32.361991
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.470898,74.0866659 C25.1100613,68.6311755 19.379503,59.3944225 18.8170113,48.6614414 C18.5481017,43.5303406 19.4896256,38.6158641 21.3919148,34.1952964 C25.3229488,36.3253316 29.8763014,37.9447097 30.8372478,40.9410327 C32.5734717,46.3547453 30.1350012,46.019868 25.3348461,50.471472 C20.534691,54.923076 19.4690677,60.6497691 30.1822178,65.4185781 C36.6300483,68.2887396 34.9257872,71.5645246 33.470898,74.0866659 Z",
    id: "Combined-Shape",
    fill: "url(#radialGradient-2)",
    opacity: 0.327566964,
    transform: "translate(26.796434, 54.140981) rotate(-30.000000) translate(-26.796434, -54.140981) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.221836,66.070082 C14.384166,61.0611878 11.968238,54.8803317 11.6130459,48.1028634 C10.8356068,33.2684409 20.1753865,20.2446375 33.599242,15.7319375 C33.2722291,20.4625423 31.0018925,19.5989545 25.33067,22.1052832 C19.3427338,24.7515799 16.4707382,29.8193416 25.0476483,37.8161995 C32.4354966,44.7044113 22.6494662,49.5148458 19.3065502,55.3049462 C18.1899322,57.2389853 17.8283615,60.8273639 18.2218382,66.070082 L18.221836,66.070082 Z",
    id: "Combined-Shape",
    fill: "url(#radialGradient-3)",
    opacity: 0.764973958,
    transform: "translate(22.583567, 40.901010) rotate(-29.000000) translate(-22.583567, -40.901010) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6735907,39.5377965 C69.080182,36.7684304 66.0766561,33.2558808 63.9024015,29.2156941 C64.8179726,30.1913158 66.3543255,31.1606702 68.7315917,32.2689837 C73.9454502,34.699755 73.739566,37.3054423 72.6735907,39.5377965 Z M62.7977735,26.9555947 C61.2557636,23.460247 60.3110923,19.6307088 60.0992752,15.5889989 C59.8376783,10.5974313 60.7215778,5.81086647 62.5211249,1.48457756 C66.1208073,3.75626814 69.2371663,6.64817254 67.5998903,12.7585697 C65.5798847,20.2973332 62.4977393,24.0523312 62.7977735,26.9555947 Z",
    id: "Combined-Shape-Copy-6",
    fill: "url(#radialGradient-4)",
    opacity: 0.430059524,
    transform: "translate(66.669088, 20.511187) rotate(161.000000) translate(-66.669088, -20.511187) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ico-accounts",
    transform: "translate(32.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#92AADC",
    opacity: 0.264880952,
    x: 6.73684211,
    y: 6.73684211,
    width: 19.951417,
    height: 19.951417,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#92AADC",
    opacity: 0.50297619,
    x: 3.36842105,
    y: 3.36842105,
    width: 19.951417,
    height: 19.951417,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "url(#linearGradient-5)",
    x: 0,
    y: 0,
    width: 19.951417,
    height: 19.951417,
    rx: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "smiling-emoticon-square-face",
    transform: "translate(36.000000, 26.000000)",
    fill: "#092288",
    stroke: "#0A2288",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1546916,1.74033645 C7.83454206,-0.580037383 4.05970093,-0.580037383 1.74,1.7397757 C-0.580149533,4.05958879 -0.579925234,7.83454206 1.7402243,10.1548037 C4.05970093,12.4745047 7.83454206,12.4745047 10.1544673,10.1543551 C12.4743925,7.83454206 12.4742804,4.05981308 10.1546916,1.74033645 Z M9.50545794,9.50557009 C7.54351402,11.467514 4.35106542,11.4677383 2.38900935,9.50579439 C0.426616822,7.54351402 0.426841121,4.35072897 2.38900935,2.38878505 C4.35095327,0.426953271 7.54328972,0.426728972 9.50568224,2.38900935 C11.4676262,4.35095327 11.4674019,7.54373832 9.50545794,9.50557009 Z M3.72785047,4.33693458 C3.72785047,3.95293458 4.03928972,3.64149533 4.42328972,3.64149533 C4.80717757,3.64149533 5.11861682,3.95282243 5.11861682,4.33693458 C5.11861682,4.72115888 4.80717757,5.03248598 4.42328972,5.03248598 C4.03928972,5.03248598 3.72785047,4.72115888 3.72785047,4.33693458 Z M6.88115888,4.33693458 C6.88115888,3.95293458 7.19282243,3.64149533 7.57682243,3.64149533 C7.96071028,3.64149533 8.27214953,3.95282243 8.27214953,4.33693458 C8.27214953,4.72115888 7.96082243,5.03248598 7.57682243,5.03248598 C7.19282243,5.03248598 6.88115888,4.72115888 6.88115888,4.33693458 Z M8.52527103,7.18519626 C8.09428037,8.18186916 7.08493458,8.82583178 5.95401869,8.82583178 C4.79876636,8.82583178 3.78347664,8.17861682 3.36740187,7.1768972 C3.29607477,7.00542056 3.37738318,6.80848598 3.54908411,6.73715888 C3.59125234,6.7197757 3.63499065,6.71147664 3.67805607,6.71147664 C3.80994393,6.71147664 3.9351028,6.78942056 3.98882243,6.91895327 C4.30026168,7.66878505 5.07162617,8.15304673 5.95401869,8.15304673 C6.8164486,8.15304673 7.5833271,7.6684486 7.90766355,6.91816822 C7.98145794,6.74758879 8.17951402,6.66897196 8.34998131,6.7428785 C8.5204486,6.81678505 8.59906542,7.01472897 8.52527103,7.18519626 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAOneOffBonus);
export default __webpack_public_path__ + "static/media/A-one-off-bonus.3e84d8222dd93447efe333c175cb87b0.svg";
export { ForwardRef as ReactComponent };